import React from "react";

const NotFound = () => {
  return <div>Whoooops ... nothing found here</div>;
};

export default NotFound;
